import { images } from '.'; 

const gadziakData = [  
    {
        id: 1,
        image: images.gadziak_main,
        title: "gadziak.title",
        date: "",
        paragraphs: [
            "gadziak.paragraphs.0",
            "gadziak.paragraphs.1",
            "gadziak.paragraphs.2",
            "gadziak.paragraphs.3",
            "gadziak.paragraphs.4",
            "gadziak.paragraphs.5",
        ],
    },
];

export default gadziakData;